module.exports = __webpack_public_path__ + "img/logo-2.650d9e76.svg";